import { Component, OnInit } from '@angular/core';
import { UserSessionService } from '../../services/user-session.service';
import { ControlflowService } from '../../services/controlflow.service';

interface ControlFlowWorkflow {
  id: number;
  name: string;
  description?: string;
  status: 'ATIVO' | 'INATIVO';
  workflow_type?: 'PROCESS' | 'CHATBOT';
  assistant_command_id?: number | null;
  trigger: string;
  steps: number;
  last_run_at?: string | null;
}

@Component({
  selector: 'app-controlflow',
  templateUrl: './controlflow.component.html',
  styleUrls: ['./controlflow.component.scss']
})
export class ControlflowComponent implements OnInit {
  tenantId: number | null = null;
  workflows: ControlFlowWorkflow[] = [];
  loading = false;

  constructor(
    private userSession: UserSessionService,
    private controlflowService: ControlflowService
  ) {}

  ngOnInit() {
    const user = this.userSession.getUser();
    this.tenantId = user?.tenant_id || null;
    this.loadWorkflows();
  }

  get totalWorkflows() {
    return this.workflows.length;
  }

  get activeWorkflows() {
    return this.workflows.filter((flow) => flow.status === 'ATIVO').length;
  }

  get totalSteps() {
    return this.workflows.reduce((sum, flow) => sum + flow.steps, 0);
  }

  private loadWorkflows() {
    if (!this.tenantId) {
      this.workflows = [];
      return;
    }
    this.loading = true;
    this.controlflowService.listWorkflows(this.tenantId).subscribe({
      next: (rows) => {
        this.workflows = rows || [];
        this.loading = false;
      },
      error: () => {
        this.workflows = [];
        this.loading = false;
      }
    });
  }
}
